import { gql } from "@apollo/client";

export const getDivisionAndMillLocations = gql`
    query locations($mill_id: Int!) {
        mill(where: { mill_id: { _eq: $mill_id } }) {
            mill_id
            name
            dedicated_localserver
            division_id
            cluster_enabled
        }
    }
`;
